export default class OfferingCategory {

    static DEFAULT_COURSE = 'course';
    static DEFAULT_EXAM = 'exam';
    static DEFAULT_TRAINING = 'training';
    static DEFAULTS = [
        OfferingCategory.DEFAULT_COURSE,
        OfferingCategory.DEFAULT_EXAM,
        OfferingCategory.DEFAULT_TRAINING,
    ];

    static fromData(data) {
        if (!data) {
            return;
        }

        const offeringCategory = new OfferingCategory();
        offeringCategory.id = data.id;
        offeringCategory.name = data.name;
        offeringCategory.backgroundColor = data.backgroundColor;
        offeringCategory.isDefault = data.isDefault;
        offeringCategory.isArchived = data.isArchived;
        offeringCategory.isDeletable = data.isDeletable;
        offeringCategory.isArchivable = data.isArchivable;
        offeringCategory.reasonForNotArchivable = data.reasonForNotArchivable;
        offeringCategory.reasonForNotDeletable = data.reasonForNotDeletable;
        offeringCategory.delete = false;

        return offeringCategory;
    }

    static create() {
        const offeringCategory = new OfferingCategory();
        offeringCategory.id = null;
        offeringCategory.name = '';
        offeringCategory.backgroundColor = '#ffffff';
        offeringCategory.edit = true;
        offeringCategory.delete = false;
        offeringCategory.isArchived = false;
        offeringCategory.isDeletable = true;
        offeringCategory.isDefault = false;
        return offeringCategory;
    }

    static isDefault(name) {
        return OfferingCategory.DEFAULTS.includes(name);
    }

    equals(offeringCategory){
        if (offeringCategory.id === null) {
            return false;
        }
        return offeringCategory.id === this.id;
    }

    serialize() {
        return {
            id: this.id || null,
            name: this.name,
            backgroundColor: this.backgroundColor,
            isArchived: this.isArchived || false,
            delete: this.delete || false,
        };
    }
}
